export default __webpack_public_path__ + "static/media/Lamborghini_Retro.a3681ec2.jpg";